<template>
  <div :class="modal ? 'modal is-active' : 'modal'">
    <div class="modal-background"></div>
    <div class="modal-card is-small">
      <header class="modal-card-head">
        <button @click="closeModal()" class="delete" aria-label="close"></button>
        <p class="modal-card-title">CLEAR CART</p>	
      </header>
      
      <section class="modal-card-body has-text-centered ph15">
       <template>
          <img src="@/assets/img/icon-basket.svg" alt="Basket" class="mt20 mb20">
          <p class="modal-card-title is-size-14 mb10 mb15">Are you sure ?<br/>
          </p>
       </template>
      </section>

      <footer class="modal-card-foot">
        <div class="next-prev-button">
          <button class="button is-large bg-secondary hover-opacity-7 text-white is-full-width" @click.prevent="clearCart()">Clear Now</button>
          <button class="button is-large is-white is-full-width" @click.prevent="closeModal()">Cancel</button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import CartApis from '@/Components/Controllers/CartApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import Env from '@/env';
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';

export default {
  name: 'CartClear',
  data() {
    return {
      modal: false,
    };
  },
   computed: {
    ...mapGetters({
      vg_cartId: "cart/id",
      vg_selectedStore: "location/selected",
      vg_cartPromoCode: "cart/promocode",
    }),
   },
  
  mounted() {
    bus.$on('show-modal-clear-cart', (payload) => {
      this.modal = payload;
    })
  },
  
  beforeDestroy() {
    bus.$off('show-modal-clear-cart');
  },
  
  methods: {
    closeModal() {
      this.modal = false;
    },
    /**
    * Clear cart
     */
     async clearCart() {
        let res = await CartApis.clearcart(this.vg_cartId)
          .then(res => res)
          .catch(err => err);
        if(res.status == 200){
          // Empty vbout cart
          if(this.$store.getters.getLoggedInUserToken){
            await VboutApis.emptyCart(this.vg_cartId, this.vg_selectedStore.id)
          }
          this.closeModal();
        }
        this.va_snackbar({
          message: res.status == 200 ? "Cart successfully cleared." : Helpers.catchErrorMessage(res.response.data),
          type: res.status == 200 ? "success" :  "warning",
        });
    },
    
    ...mapActions({
      va_snackbar: "snackbar/setSnackbar",
    })
  },
};
</script>